// Per-particle color pick for the CTA sparkle burst: indices into
// the 3-slot tier palette (partial/outcome/exact), resolved to an actual color
// by GameweekGrid.css depending on light/dark theme. A fixed hand-shuffled
// literal rather than `Math.random` during render — the burst never varied per
// mount in any way the eye can catch (the particles float on an infinite CSS
// animation), and rendering must stay pure.
const START_CTA_PARTICLE_COLORS = [0, 2, 1, 0, 1, 2, 2, 0, 1, 2]

interface StartCtaCardProps {
  gameweek: number
  fixtureCount: number
  onStartCycle: () => void
}

/** The untouched-gameweek hero: the poster-sized "Predict all N" button plus its floating
 *  sparkle particles. Extracted from GameweekGrid.tsx. */
function StartCtaCard({ gameweek, fixtureCount, onStartCycle }: StartCtaCardProps) {
  return (
    <div className="gameweek-grid__start-cta-wrap">
      <button type="button" className="gameweek-grid__start-cta" onClick={onStartCycle}>
        <span className="gameweek-grid__start-cta-badge label-eyebrow">
          Gameweek {gameweek}
        </span>
        {/* Count comes off the same `games` list the grid and the pick cycle
            render — never a constant, so a postponed fixture
            can't leave the CTA promising more than the flow delivers. */}
        <span className="gameweek-grid__start-cta-title">Predict all {fixtureCount}</span>
        {/* The card is a button, but at this size it reads as a poster —
            the small line is what names the affordance. Static copy: the
            count already lives in the headline above, and the whole
            point was that it be stated exactly once. */}
        <span className="gameweek-grid__start-cta-subtitle">Tap to start</span>
      </button>
      {START_CTA_PARTICLE_COLORS.map((colorIndex, index) => (
        <span
          key={index}
          className="gameweek-grid__start-cta-particle"
          data-spark-color={colorIndex}
          aria-hidden="true"
        />
      ))}
    </div>
  )
}

export default StartCtaCard
